<template>
<div style="text-align:center" class="alert alert-danger">
    <h2>{{ titulo }}</h2>
    <h3>{{ rotaOrigem }}</h3>
</div>
</template>

<script>
export default {
  data () {
    return {
      titulo: 'Você não tem permissão para acessar essa página!',
      rotaOrigem: this.$route.query.value
    }
  }
}
</script>

<style>
</style>
